// src/services/userService.ts

import apiClient from './apiClient';

// This function will call your back-end to get the user's
// application-specific profile, including roles and permissions.
export const getUserProfile = async (): Promise<any> => {
  const response = await apiClient.get('/profile');
  return response.data;
};